<template>
  <div class="ClassifyManagement">
    <AppHeader>目录管理</AppHeader>
    <AppBox class="appBox">
      <div class="tableFilter">
        <el-button type="primary" plain @click="handleAddClassify"
                   v-show="permissionCode.has('research:dir:manager')"
        >新增目录
        </el-button>
      </div>
      <ClassifyList></ClassifyList>
    </AppBox>
  </div>
</template>

<script>
import AppBox from "@/components/ui/AppBox/index.vue";
import AppHeader from "@/components/ui/AppHeader/index.vue";
import ClassifyList from "@/pages/ClassifyManagement/ClassifyList.vue";
import {mapState} from "vuex";

export default {
  name: "ClassifyManagement",
  components: {ClassifyList, AppHeader, AppBox},
  data() {
    return {};
  },
  computed: {
    ...mapState("user", ["permissionCode"])
  },
  methods: {
    async handleAddClassify() {
      await this.$router.push(
          {
            name: "AddClassify",
            params: {
              type: "add",
              id: this.$Base64.encode(0),
            }
          }
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.ClassifyManagement {
  .appBox {
    min-height: calc(100vh - 155px);

    .tableFilter {
      padding-bottom: 20px;
      text-align: right;
    }
  }
}
</style>
